import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Backdrop, Modal } from './styled';

const CustomizeAvatarModal = ({ onClose, isOpen, children, background }) => {
  useLayoutEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = 'hidden';
      document.documentElement.style.height = '100%';
    }
    return () => {
      document.body.style.overflowY = null;
      document.documentElement.style.height = null;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <Backdrop onClick={onClose}>
      <Modal background={background} onClick={(e) => e.stopPropagation()}>
        {children}
      </Modal>
    </Backdrop>
  );
};

CustomizeAvatarModal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  background: PropTypes.string
};

export default CustomizeAvatarModal;
